import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { T } from "@/components/T";

export function KohlbrennerShowcase() {
  return (
    <section data-testid="referenzprojekt-section" style={{ background: "#0b0c0e" }}>
      <div className="grid grid-cols-1 lg:grid-cols-2" style={{ minHeight: "clamp(480px, 60vw, 760px)" }}>
        <div className="relative overflow-hidden group order-2 lg:order-1" style={{ minHeight: "clamp(300px, 38vw, 580px)" }}>
          <img loading="lazy" src="/assets/fotos/hb-foto-k3.webp" alt="Kohlbrenner Lodges – Holzbuddy Mölten"
            className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-[1.03]" style={{ objectPosition: "center" }} />
          <div className="absolute inset-0 hidden lg:block" style={{ background: "linear-gradient(to right, transparent 55%, rgba(11,12,14,0.85) 100%)" }} />
          <div className="absolute inset-0 lg:hidden" style={{ background: "linear-gradient(to top, rgba(11,12,14,0.6) 0%, transparent 50%)" }} />
        </div>
        <div className="flex flex-col justify-between px-8 lg:px-16 py-12 lg:py-20 order-1 lg:order-2">
          <div>
            <div className="flex items-center gap-3 mb-8">
              <span className="block w-5 h-px" style={{ background: "#f5c800" }} />
              <span className="text-[9px] tracking-[0.3em] uppercase font-semibold font-inter" style={{ color: "rgba(245,200,0,0.65)" }}>
                <T de="Referenzprojekt · Hotelbau" it="Progetto di riferimento · Edilizia alberghiera" />
              </span>
            </div>
            <h2 className="font-bebas text-white leading-none mb-3" style={{ fontSize: "clamp(44px, 5.5vw, 80px)" }}>
              Kohlbrenner<br />Lodges
            </h2>
            <p className="text-sm font-inter mb-8" style={{ color: "rgba(255,255,255,0.35)" }}>
              <T de="Mölten, Südtirol · 2024" it="Mölten, Alto Adige · 2024" />
            </p>
            <p className="text-sm font-inter leading-relaxed" style={{ color: "rgba(255,255,255,0.55)", maxWidth: "380px" }}>
              <T de="Neubau eines Premium-Ferienresorts in massiver Holzbauweise – Holzfassade, Dachstuhl, Balkone und Zimmerei. Präzise geplant, sauber umgesetzt."
                 it="Nuova costruzione di un resort vacanze premium in massiccia costruzione in legno – facciata in legno, struttura del tetto, balconi e carpenteria. Pianificato con precisione, realizzato con cura." />
            </p>
            <div className="grid grid-cols-3 gap-4 mt-10 pt-8 border-t border-white/10">
              {[
                { val: "5", label: { de: "Lodges", it: "Lodges" } },
                { val: "2024", label: { de: "Fertiggestellt", it: "Completato" } },
                { val: "Mölten", label: { de: "Standort", it: "Ubicazione" } },
              ].map((s) => (
                <div key={s.val}>
                  <p className="font-bebas mb-0.5" style={{ fontSize: "clamp(22px, 2.5vw, 32px)", color: "#f5c800" }}>{s.val}</p>
                  <p className="text-[9px] uppercase tracking-widest font-inter" style={{ color: "rgba(255,255,255,0.28)" }}>
                    <T de={s.label.de} it={s.label.it} />
                  </p>
                </div>
              ))}
            </div>
          </div>
          <div className="mt-10">
            <div className="grid grid-cols-3 gap-2 mb-8">
              {[
                { src: "/assets/fotos/hb-foto-k4.webp", alt: "Kohlbrenner Lodges Außenansicht" },
                { src: "/assets/fotos/hb-foto-k2.webp", alt: "Whirlpool Terrasse mit Bergblick" },
                { src: "/assets/fotos/hb-foto-k5.webp", alt: "Kohlbrenner Lodges Südtirol" },
              ].map((img, i) => (
                <div key={i} className="overflow-hidden" style={{ aspectRatio: "1/1" }}>
                  <img loading="lazy" src={img.src} alt={img.alt} className="w-full h-full object-cover hover:scale-110 transition-transform duration-500" />
                </div>
              ))}
            </div>
            <Link to="/projekte/kohlbrenner-lodges-moelten" data-testid="referenzprojekt-link"
              className="inline-flex items-center gap-3 text-xs tracking-widest uppercase font-semibold font-inter hover:text-hb-yellow transition-colors duration-200"
              style={{ color: "rgba(255,255,255,0.5)" }}>
              <T de="Zum Projekt" it="Al progetto" /> <ArrowRight size={12} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
